<template>
    <transition>
    <div class="container-fluid page-content">
        <!-- Modern Page Header -->
        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center page-header-row gap-3">
            <div>
                <h4 class="page-title text-slate-800 fw-bold mb-1">Unit</h4>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item"><a href="/" class="text-muted"><i class="fas fa-home me-1"></i>Home</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" class="text-muted">Product Settings</a></li>
                        <li class="breadcrumb-item active text-indigo fw-medium" aria-current="page">Unit List</li>
                    </ol>
                </nav>
            </div>
            <div>
                <button type="button" class="btn btn-premium d-flex align-items-center gap-2" @click="toggleModal()" v-if="permission['unit-create']">
                    <i class="fas fa-plus"></i> Add New Unit
                </button>
            </div>
        </div>

        <!-- Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content border-0 shadow-lg modal-premium modal-premium-md">
                <div class="modal-header">
                    <h4 class="fw-bold m-0">{{ editMode ? 'Update Unit' : 'Create New Unit' }}</h4>
                    <button @click="toggleModal()" type="button" class="btn-close-custom">✕</button>
                </div>
                <form @submit.prevent="submitForm()" enctype="multipart/form-data">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="unit_code" class="form-label-custom text-slate-700 fw-semibold mb-2">Unit Code *</label>
                                            <input type="text" class="form-control-custom" :class="{'is-invalid': errors.unit_code}" @keypress="onkeyPress('unit_code')" v-model="form.unit_code" id="unit_code" placeholder="Unit Code" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.unit_code">
                                                {{errors.unit_code[0]}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="unit_name" class="form-label-custom text-slate-700 fw-semibold mb-2">Unit Name *</label>
                                            <input type="text" class="form-control-custom" :class="{'is-invalid': errors.unit_name}" @keypress="onkeyPress('unit_name')" v-model="form.unit_name" id="unit_name" placeholder="Unit Name" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.unit_name">
                                                {{errors.unit_name[0]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="base_unit" class="form-label-custom text-slate-700 fw-semibold mb-2">Base Unit</label>
                                            <select class="form-select-custom" :class="{'is-invalid': errors.base_unit}" v-model="form.base_unit" @change="onkeyPress('base_unit')" id="base_unit">
                                                <option value="0">Select Base Unit</option>
                                                <option v-for="(unit, index) in items" :value="unit.id" :key="index">{{ unit.unit_name }} ({{ unit.unit_code }})</option>
                                            </select>
                                            <div class="invalid-feedback" v-if="errors.base_unit">
                                                {{errors.base_unit[0]}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="operator" class="form-label-custom text-slate-700 fw-semibold mb-2">Operator</label>
                                            <input type="text" class="form-control-custom" :class="{'is-invalid': errors.operator}" @keypress="onkeyPress('operator')" v-model="form.operator" id="operator" placeholder="Operator Value" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.operator">
                                                {{errors.operator[0]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="operation_value" class="form-label-custom text-slate-700 fw-semibold mb-2">Operation Value</label>
                                            <input type="text" class="form-control-custom" :class="{'is-invalid': errors.operation_value}" @keypress="onkeyPress('operation_value')" v-model="form.operation_value" id="operation_value" placeholder="operation_value Value" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.operation_value">
                                                {{errors.operation_value[0]}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <div class="mb-3">
                                            <label for="ustatus" class="form-label-custom text-slate-700 fw-semibold mb-2">Status</label>
                                            <select class="form-select-custom" :class="{'is-invalid': errors.status}" v-model="form.status" @change="onkeyPress('status')" id="ustatus">
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                            <div class="invalid-feedback" v-if="errors.status">
                                                {{errors.status[0]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-outline-premium me-2" @click="toggleModal()">Cancel</button>
                        <button type="submit" class="btn btn-premium" :disabled="disabled">
                            <span v-show="isSubmit" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            {{ editMode ? 'Update Unit' : 'Create Unit' }}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>

        <!-- Modern Filter Bar -->
        <div class="card border-0 shadow-sm filter-card">
            <div class="card-body p-3">
                <div class="row align-items-center g-2">
                    <div class="col-md-6 col-sm-6 d-flex align-items-center gap-2">
                        <span class="text-muted text-nowrap">Show</span>
                        <select class="form-select-custom length-select" v-model="tableData.length" @change="getDataItems()">
                            <option value="10" selected="selected">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option :value="pagination.total">All</option>
                        </select>
                        <span class="text-muted text-nowrap">entries</span>
                    </div>
                    <div class="col-md-6 col-sm-6 d-flex justify-content-sm-end">
                        <div class="position-relative search-container">
                            <i class="fas fa-search search-icon text-muted"></i>
                            <input type="text" class="form-control-custom search-input" v-model="tableData.search" placeholder="Search units..." @input="getDataItems()">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modern Table Card -->
        <div class="card border-0 shadow-sm table-card">
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table table-premium mb-0" v-if="!loading && items.length > 0">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 5%;">SL</th>
                                <th class="text-start" style="width: 12%;">Unit Code</th>
                                <th class="text-start" style="width: 15%;">Unit Name</th>
                                <th class="text-start" style="width: 15%;">Base Unit</th>
                                <th class="text-start" style="width: 12%;">Operator</th>
                                <th class="text-start" style="width: 15%;">Operation Value</th>
                                <th class="text-center" style="width: 10%;">Status</th>
                                <th class="text-center" style="width: 8%;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in items" :key="i">
                                <td class="text-center text-muted fw-semibold">{{ (pagination && pagination.currentPage ? (pagination.currentPage - 1) * tableData.length : 0) + i + 1 }}</td>
                                <td class="text-start">
                                    <span class="fw-bold text-slate-800">{{ item.unit_code }}</span>
                                </td>
                                <td class="text-start">{{ item.unit_name }}</td>
                                <td class="text-start text-muted">{{ item.base_unit_name }}</td>
                                <td class="text-start text-muted">{{ item.operator }}</td>
                                <td class="text-start text-muted">{{ item.operation_value }}</td>
                                <td class="text-center">
                                    <span v-if="item.status==1" @click="changeStatus(item, 0)" class="badge badge-role-active" style="cursor: pointer;">Active</span>
                                    <span v-if="item.status==0" @click="changeStatus(item, 1)" class="badge badge-role-inactive" style="cursor: pointer;">Inactive</span>
                                </td>
                                <td class="text-center">
                                    <div class="dropdown">
                                        <button class="btn btn-icon" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg dropdown-premium">
                                            <li v-if="permission['unit-edit']">
                                                <a class="dropdown-item text-primary" href="javascript:void(0);" @click="edit(item)">
                                                    <i class="fas fa-edit me-2"></i>Edit
                                                </a>
                                            </li>
                                            <li v-if="permission['unit-edit'] && permission['unit-delete']"><hr class="dropdown-divider"></li>
                                            <li v-if="permission['unit-delete']">
                                                <a class="dropdown-item text-danger" href="javascript:void(0);" @click="deleteItem(item)">
                                                    <i class="fas fa-trash-alt me-2"></i>Remove
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Empty State -->
                    <div v-if="!loading && items.length === 0" class="text-center py-5">
                        <img src="../../assets/image/loading.gif" class="mb-3 opacity-25" style="width: 80px; filter: grayscale(1);" />
                        <h5 class="text-muted fw-semibold">No Data Found</h5>
                        <p class="text-muted mb-0 small">Try adjusting your filters or search keywords.</p>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                        <div class="spinner-premium mb-3"></div>
                        <h5 class="text-muted fw-semibold">Loading Data</h5>
                        <p class="text-muted mb-0 small">Please wait a moment...</p>
                    </div>
                </div>

                <!-- Modern Pagination Footer -->
                <div class="card-footer border-0 bg-white py-3 px-4 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3" v-if="pagination && items.length > 0">
                    <div class="text-muted small">
                        Showing <span class="fw-semibold text-slate-800">{{ pagination.from }}</span> to <span class="fw-semibold text-slate-800">{{ pagination.to }}</span> of <span class="fw-semibold text-slate-800">{{ pagination.total }}</span> entries
                    </div>
                    <Pagination 
                        :pagination="pagination"  
                        :language="lang"
                        @onChangePage="setPage" > 
                    </Pagination>
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct';


import Modal from "./../helper/Modal.vue";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from "vform";
import axios from "axios";
export default {
    name: "Unit",
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            btn:'Create',
            items: [],
            form: new Form({
                id: '',
                unit_code: '',
                unit_name: '',
                base_unit: 0,
                operator: '*',
                operation_value: 1,
                status: 1,
            }), 
            columns: [ 
                {
                    label: 'Unit Code',
                    name: 'unit_code',           
                    width: '15%'
                }, 
                {
                    label: 'Unit Name',
                    name: 'unit_name',           
                    width: '15%'
                }, 
                {
                    label: 'Base Unit',
                    name: 'base_unit',
                    width: '20%'
                },
                {
                    label: 'Operator',
                    name: 'operator',
                    width: '15%'
                },
                {
                    label: 'Operation Value',
                    name: 'operation_value',
                    width: '15%'
                },
                {
                    label: 'Status',
                    name: 'status',
                    width: '10%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                sortKey: 'name', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }
        }
    },
    created() {
        this.getDataItems();
    },

    methods: {
        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            console.log('this.modalActive', this.modalActive)
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset(); 
        },
        fetchUnitData() { 
            axios.get(this.apiUrl+'/units', this.headers)
            .then((res) => {
                this.items = res.data.data;
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        edit: function(item) {
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item); 
        },
        submitForm: function(e) { 
            
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();  
            formData.append('unit_code', this.form.unit_code);
            formData.append('unit_name', this.form.unit_name);
            formData.append('base_unit', this.form.base_unit);
            formData.append('operator', this.form.operator);
            formData.append('operation_value', this.form.operation_value);
            formData.append('status', this.form.status); 
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/units/'+this.form.id, formData, this.headers);
            }else{
                var postEvent = axios.post(this.apiUrl+'/units', formData, this.headers);
            }           

            postEvent.then(res => {
                
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.getDataItems(this.apiUrl+'/units?page='+this.pagination.currentPage);
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
        },

        changeStatus: function(item, newStatus) {
            const formData = new FormData();
            formData.append('unit_code', item.unit_code);
            formData.append('unit_name', item.unit_name);
            formData.append('base_unit', item.base_unit || 0);
            formData.append('operator', item.operator || '*');
            formData.append('operation_value', item.operation_value || 1);
            formData.append('status', newStatus);
            formData.append('_method', 'put');
            
            axios.post(this.apiUrl+'/units/'+item.id, formData, this.headers)
            .then(res => {
                if(res.status == 200){
                    this.getDataItems(this.apiUrl+'/units?page='+this.pagination.currentPage);
                    this.$toast.success(res.data.message || "Status updated successfully");
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {
                this.$toast.error(err.response?.data?.message || "An error occurred");
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            console.log('item delete=>',item.id);
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/units/'+item.id, this.headerjson)
                    .then(res => {
                        if(res.status == 200){ 
                            this.getDataItems(this.apiUrl+'/units?page='+this.pagination.currentPage);
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },
        // For Pagination 
        getDataItems(url = this.apiUrl+'/units') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData, headers: this.headerparams})
            .then((response) => {
                console.log('response', response.data.data);
                this.items = response.data.data;   
                this.configPagination(response.data.meta); 
            })
            .catch(errors => {
                this.$toast.error(errors);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key; 
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable;  
            this.getDataItems();
        },
        setPage(data){  
            this.getDataItems(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        }
    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        permission() {
            let pname = this.$route.meta.parent_module;
            let module_name = this.$route.meta.module_name;
            let path_name = this.$route.path; 
            let data = '';
            if(this.$route.meta.parent_module){
                data = this.$store.getters.userAllPermissions[pname][0].children[path_name]
            }else{
                data = this.$store.getters.userAllPermissions[module_name][0].other_actions; 
            } 
            return data;
        },
    }
}
</script>